var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReduce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6.75H10.5C10.6989 6.75 10.8897 6.82902 11.0303 6.96967C11.171 7.11032 11.25 7.30109 11.25 7.5V16.5C11.25 16.6989 11.171 16.8897 11.0303 17.0303C10.8897 17.171 10.6989 17.25 10.5 17.25H7.5C7.30109 17.25 7.11032 17.171 6.96967 17.0303C6.82902 16.8897 6.75 16.6989 6.75 16.5V7.5C6.75 7.30109 6.82902 7.11032 6.96967 6.96967C7.11032 6.82902 7.30109 6.75 7.5 6.75ZM8.25 15.75H9.75V8.25H8.25V15.75ZM1.5 0.75H4.5C4.69891 0.75 4.88968 0.829018 5.03033 0.96967C5.17098 1.11032 5.25 1.30109 5.25 1.5V16.5C5.25 16.6989 5.17098 16.8897 5.03033 17.0303C4.88968 17.171 4.69891 17.25 4.5 17.25H1.5C1.30109 17.25 1.11032 17.171 0.969669 17.0303C0.829018 16.8897 0.75 16.6989 0.75 16.5V1.5C0.75 1.30109 0.829018 1.11032 0.969669 0.96967C1.11032 0.829018 1.30109 0.75 1.5 0.75ZM2.25 15.75H3.75V2.25H2.25V15.75ZM13.5 11.25H16.5C16.6989 11.25 16.8897 11.329 17.0303 11.4697C17.171 11.6103 17.25 11.8011 17.25 12V16.5C17.25 16.6989 17.171 16.8897 17.0303 17.0303C16.8897 17.171 16.6989 17.25 16.5 17.25H13.5C13.3011 17.25 13.1103 17.171 12.9697 17.0303C12.829 16.8897 12.75 16.6989 12.75 16.5V12C12.75 11.8011 12.829 11.6103 12.9697 11.4697C13.1103 11.329 13.3011 11.25 13.5 11.25ZM14.25 15.75H15.75V12.75H14.25V15.75Z",
    fill: "#A5ACBC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24998 1.5L15.6785 7.82143",
    stroke: "#A5ACBC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1519 8.12967L15.6012 8.22929C15.9168 8.24213 16.1651 7.96264 16.1152 7.65069L15.7279 5.23021",
    stroke: "#A5ACBC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReduce);
export default __webpack_public_path__ + "static/media/reduce.179deb992720201e1f47023d73949c26.svg";
export { ForwardRef as ReactComponent };